import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { setLastZone } from "../../../services/app/localStorage";

const TheRescuerURL = ({ to }) => {
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		const pathname = location.pathname;
		const search = location.search;
		setLastZone(`${pathname}${search}`);
		navigate(to);
	}, [to, location, navigate]);

	return <>Por favor, espere un momento, los estamos redireccionando...</>;
};

export default TheRescuerURL;
